"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _lodash = _interopRequireDefault(require("lodash"));
var _clientsListMixin = require("@/mixins/clientsListMixin");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  name: 'AuditClientsList',
  bodyClass: 'audit-clients-list-page',
  components: {
    TableListClients: _components.TableListClients
  },
  mixins: [_clientsListMixin.clientsListMixin],
  data: function data() {
    return {
      activeTab: 0,
      filter: ''
    };
  },
  computed: {
    list: function list() {
      return _lodash.default.orderBy(this.listAllClients, ['name']);
    },
    listClients: function listClients() {
      var _this = this;
      if (this.filter.length) {
        return this.list.filter(function (p) {
          return p.name.toUpperCase().indexOf(_this.filter.toUpperCase()) >= 0 || p.document.indexOf(_this.filter) >= 0;
        });
      }
      return this.list;
    }
  },
  methods: {
    openDetailLogFiles: function openDetailLogFiles(item) {
      this.$router.push({
        path: "/audit/logfiles/".concat(item._id)
      });
    }
  }
};